module.exports = __webpack_public_path__ + "img/cash.132a48f2.svg";